(function (window) {
  var thisJQuery = jQuery;
  var atomdot = null;
  if (typeof ShopifyAnalytics.meta.product !== "undefined") {
    if (window.atomdot) {
      atomdot = window.atomdot;
    } else {
      atomdot = {
        countdowntimer: {
          title: "Sale ends in",
          showPoweredBy: false,
          setShowPoweredBy: null,
          showCountdownTimer: null,
          refreshCountdownTimer: null
        },
      };
    }
  }
  var timerInterval = null;
  var setTimeoutId = null;
  
  function setTimeout_(fn, delay) {
    var maxDelay = Math.pow(2, 31) - 1;

    if (delay > maxDelay) {
      var args = arguments;
      args[1] -= maxDelay;

      return setTimeout(function () {
        setTimeout_.apply(undefined, args);
      }, maxDelay);
    }

    return setTimeout.apply(undefined, arguments);
  }
  function addCountdownTimerCss() {
    thisJQuery("html head").append(`<style type="text/css">
      .atm__countdown-timer{
        padding:10px 5px;
        width:100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction:column;
        color: black
      }
      .atm__countdown-timer__wrapper{
        
      }
      .atm__countdown-timer__countdown{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction:column;
      }
      .atm__countdown-timer__countdown__title{
        // align-self: stretch;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        font-size:24px;
        line-height:30px;
        letter-spacing:1px;
        color:#df0104;
        text-align:left;
      }
      @media screen and (max-width: 500px) {
        .atm__countdown-timer__countdown__title {
          font-size: 18px;
          letter-spacing:0;
        }
      }

      .atm__countdown-timer__countdown__title-soon{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        border:2px dashed #df0104;
        padding:5px;
        transform: rotate(-2deg);
      }
      .atm__countdown-timer__countdown__title-soon__bottom{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .atm__countdown-timer__countdown__title-soon__bottom__item{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .atm__countdown-timer__countdown__title-soon__bottom__item:not(:last-of-type){
       margin-right:20px;
      }
      .atm__countdown-timer__countdown__title-soon__bottom__item__letter{
        display: flex;
        justify-content: center;
        align-items: center;
        width:20px;
        height:20px;
        font-size:20px;
        line-height:20px;
        font-weight:bold;
        border-radius:3px;
        color:#df0104;

        text-transform: uppercase;
      }
      .atm__countdown-timer__countdown__title-soon__bottom__item__letter:not(:last-of-type){
        margin-right:2px;
      }

      .atm__countdown-timer__countdown__title-soon__up{
       display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom:2px;
      }
      .atm__countdown-timer__countdown__title-soon__up__item{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .atm__countdown-timer__countdown__title-soon__up__item:not(:last-of-type){
       margin-right:15px;
      }
      .atm__countdown-timer__countdown__title-soon__up__item__letter{
        display: flex;
        justify-content: center;
        align-items: center;
        width:50px;
        height:50px;
        background-color: #df0104;
        font-size:60px;
        line-height:50px;
        font-weight:bold;
        border-radius:3px;
        color:white;

        text-transform: uppercase;

      }
      .atm__countdown-timer__countdown__title-soon__up__item__letter:not(:last-of-type){
        margin-right:5px;
      }


      .atm__countdown-timer__countdown__time-left{
          align-self:stretch;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top:10px;
      }
      .atm__countdown-timer__countdown__days,
      .atm__countdown-timer__countdown__hours,
      .atm__countdown-timer__countdown__minutes,
      .atm__countdown-timer__countdown__seconds{
          display: flex;
          justify-content: center;
          align-items: center;
      }

      .atm__countdown-timer__countdown__days__wrapper,
      .atm__countdown-timer__countdown__hours__wrapper,
      .atm__countdown-timer__countdown__minutes__wrapper,
      .atm__countdown-timer__countdown__seconds__wrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction:column;
      }
      .atm__countdown-timer__countdown__days__number,
      .atm__countdown-timer__countdown__hours__number,
      .atm__countdown-timer__countdown__minutes__number,
      .atm__countdown-timer__countdown__seconds__number{
        display:flex;
        justify-content:center;
        align-items:center;
      }

      .atm__countdown-timer__countdown__days__decade,
      .atm__countdown-timer__countdown__hours__decade,
      .atm__countdown-timer__countdown__minutes__decade,
      .atm__countdown-timer__countdown__seconds__decade,
      .atm__countdown-timer__countdown__days__unit,
      .atm__countdown-timer__countdown__hours__unit,
      .atm__countdown-timer__countdown__minutes__unit,
      .atm__countdown-timer__countdown__seconds__unit{
            width:32px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size:20px;
            line-height:32px;
            background-color:#df0104;
            color:white;
            margin-right:5px;
            font-weight:bold;
            border-radius:5px;
      }

      .atm__countdown-timer__countdown__days__decade{
        // background-image:linear-gradient(to bottom right, #840101,#df0104);
      }
      .atm__countdown-timer__countdown__days__unit{
        // background-image:linear-gradient(to bottom right, #840101,#df0104,#df0104,#df0104);
      }


      .atm__countdown-timer__countdown__hours__decade{
        // background-image:linear-gradient(to bottom right, #df0104,#df0104,#df0104,#840101);
      }
      .atm__countdown-timer__countdown__hours__unit{
        // background-image:linear-gradient(to bottom right, #df0104, #840101);
      }

      .atm__countdown-timer__countdown__minutes__decade{
        // background-image:linear-gradient(to bottom right, #840101,#df0104);
      }
      .atm__countdown-timer__countdown__minutes__unit{
        // background-image:linear-gradient(to bottom right, #840101,#df0104,#df0104,#df0104);
      }



      .atm__countdown-timer__countdown__seconds__decade{
        //  background-image:linear-gradient(to bottom right, #df0104,#df0104,#df0104,#840101);
      }
      .atm__countdown-timer__countdown__seconds__unit{
        // background-image:linear-gradient(to bottom right, #df0104, #840101);
      }

      @media screen and (max-width: 500px) {
      .atm__countdown-timer__countdown__days__decade,
      .atm__countdown-timer__countdown__hours__decade,
      .atm__countdown-timer__countdown__minutes__decade,
      .atm__countdown-timer__countdown__seconds__decade,
      .atm__countdown-timer__countdown__days__unit,
      .atm__countdown-timer__countdown__hours__unit,
      .atm__countdown-timer__countdown__minutes__unit,
      .atm__countdown-timer__countdown__seconds__unit {
            width:24px;
            font-size:20px;
            line-height:24px;
            margin-right:5px;
            font-weight:bold;
            border-radius:5px;
            margin-right:3px;
            border-radius:3px;
        }
      }

      .atm__countdown-timer__countdown__days__colon,
      .atm__countdown-timer__countdown__hours__colon,
      .atm__countdown-timer__countdown__minutes__colon{
            align-self:stretch;
            font-size:24px;
            line-height:30px;
            font-wight:bold;
            color:grey;
            margin-right:5px;
      }
      @media screen and (max-width: 500px) {
      .atm__countdown-timer__countdown__days__colon,
      .atm__countdown-timer__countdown__hours__colon,
      .atm__countdown-timer__countdown__minutes__colon{
            font-size:24px;
            line-height:24px;
            margin-right:3px;
      }

      }

      .atm__countdown-timer__countdown__days__days,
      .atm__countdown-timer__countdown__hours__hours,
      .atm__countdown-timer__countdown__minutes__minutes,
      .atm__countdown-timer__countdown__seconds__seconds{
            font-size:14px; 
            color:grey; 
            font-weight:500;
      }

      @media screen and (max-width: 500px) {

            font-size: 12px !important; 
      }

      .atm__countdown-timer__powered-by{
            display: flex;
            align-self: stretch;
            justify-content: flex-end;
            align-items: center;
      }
      .atm__countdown-timer__powered-by__lead{
            display: flex;
            align-self: stretch;
            justify-content:center;
            align-items: center;
            font-size:10px; 
            color:grey;
            margin-right:5px;
      }
      .atm__countdown-timer__powered-by__brand{
            text-decoration:none;
            // font-weight:300;
            color: grey;
            // line-height:20px;
            font-size: 10px;
            cursor:pointer;
            text-decoration:underline;
      }
      .atm__countdown-timer__powered-by__brand:hover{
            color:#df0104 !important;
      }

    </style>`);
  }

  function getTimeLeft(endDateTime) {
    var end = new Date(endDateTime);
    end = Date.parse(end) / 1000;

    var now = new Date();
    now = Date.parse(now) / 1000;

    var timeLeft = end - now;

    return timeLeft;
  }

  function getSearchParams(k) {
    var p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
      p[k] = v;
    });
    return k ? p[k] : p;
  }

  function getProductVariantId() {
    var variantId = "";
    var selectedId = "";
    var paramsId = getSearchParams("variant");
    var selectedVariantId = ShopifyAnalytics.meta.selectedVariantId;
    
    if (
      typeof paramsId !== "undefined" &&
      paramsId !== "" &&
      /^\d+$/.test(+paramsId)
    ) {
      variantId = paramsId;
    }
    if (
      (typeof variantId === "undefined" || variantId === "") &&
      typeof selectedVariantId !== "undefined" &&
      selectedVariantId !== "" &&
      /^\d+$/.test(+selectedVariantId)
    ) {
      variantId = selectedVariantId;
    }

    if (
      thisJQuery("main form select option").length > 0 &&
      thisJQuery("main form select option").filter(":selected") > 0
    ) {
      var options = thisJQuery("main form select option").filter(
        ":selected"
      );

      for (let index = 0; index < options.length; index++) {
        if (
          /^\d+$/.test(+options[index].value) &&
          options[index].value !== options[index].text
        ) {
          selectedId = options[index].value;
        }
      }
    }

    if (
      typeof ShopifyAnalytics.meta.product !== "undefined" &&
      typeof ShopifyAnalytics.meta.product.variants !== "undefined" &&
      ShopifyAnalytics.meta.product.variants.length > 0 &&
      (typeof variantId === "undefined" || variantId === "")
    ) {
      variantId = ShopifyAnalytics.meta.product.variants[0].id;
    }

    if (typeof variantId === "undefined" || variantId === "") {
      variantId = selectedId;
    }

    return variantId;
  }

  function makeTimer(timeLeft) {
    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    var seconds = Math.floor(
      timeLeft - days * 86400 - hours * 3600 - minutes * 60
    );

    // days
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__days #atm__countdown-timer__countdown__days__decade"
    ).text(`${parseInt(days / 10)}`);
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__days #atm__countdown-timer__countdown__days__unit"
    ).text(`${days % 10}`);

    //hours
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__hours #atm__countdown-timer__countdown__hours__decade"
    ).text(`${parseInt(hours / 10)}`);
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__hours #atm__countdown-timer__countdown__hours__unit"
    ).text(`${hours % 10}`);

    //minutes
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__minutes #atm__countdown-timer__countdown__minutes__decade"
    ).text(`${parseInt(minutes / 10)}`);
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__minutes #atm__countdown-timer__countdown__minutes__unit"
    ).text(`${minutes % 10}`);

    //seconds
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__seconds #atm__countdown-timer__countdown__seconds__decade"
    ).text(`${parseInt(seconds / 10)}`);
    thisJQuery(
      "#shopify-countdown-timer #shopify-countdown-timer__countdown__seconds #atm__countdown-timer__countdown__seconds__unit"
    ).text(`${seconds % 10}`);
  }

  function saleEndsIn(formEle, endTime) {
    timerInterval && clearInterval(timerInterval);

    var timeLeftInitiation = getTimeLeft(endTime);
    var days = Math.floor(timeLeftInitiation / 86400);
    var hours = Math.floor((timeLeftInitiation - days * 86400) / 3600);
    var minutes = Math.floor(
      (timeLeftInitiation - days * 86400 - hours * 3600) / 60
    );
    var seconds = Math.floor(
      timeLeftInitiation - days * 86400 - hours * 3600 - minutes * 60
    );
    formEle.append(
      `
      <div id="shopify-countdown-timer" class="atm__countdown-timer">
        <div class="atm__countdown-timer__wrapper">
          <div id="shopify-countdown-timer__countdown" class="atm__countdown-timer__countdown">
            <div id="shopify-countdown-timer__countdown__title" class="atm__countdown-timer__countdown__title">
              ${atomdot.countdowntimer.title}
            </div>
            <div id="shopify-countdown-timer__countdown__time-left" class="atm__countdown-timer__countdown__time-left">
              <!-- Days -->
              <div id="shopify-countdown-timer__countdown__days" class="atm__countdown-timer__countdown__days">
                <div class="atm__countdown-timer__countdown__days__wrapper">
                  <div class="atm__countdown-timer__countdown__days__number">
                    <span class="atm__countdown-timer__countdown__days__decade" id="atm__countdown-timer__countdown__days__decade">
                      ${parseInt(days / 10)}
                    </span>
                    <span class="atm__countdown-timer__countdown__days__unit" id="atm__countdown-timer__countdown__days__unit">
                      ${days % 10}
                    </span>
                  </div>
                  <div class="atm__countdown-timer__countdown__days__days">Days</div>
                </div>
                <div class="atm__countdown-timer__countdown__days__colon">:</div>
              </div>
              <!-- Hours -->
              <div id="shopify-countdown-timer__countdown__hours" class="atm__countdown-timer__countdown__hours">
                <div class="atm__countdown-timer__countdown__hours__wrapper">
                  <div class="atm__countdown-timer__countdown__hours__number">
                    <span class="atm__countdown-timer__countdown__hours__decade" id="atm__countdown-timer__countdown__hours__decade">
                      ${parseInt(hours / 10)}
                    </span>
                    <span class="atm__countdown-timer__countdown__hours__unit" id="atm__countdown-timer__countdown__hours__unit">
                      ${hours % 10}
                    </span>
                  </div>
                  <div class="atm__countdown-timer__countdown__hours__hours">Hrs</div>
                </div>
                <div class="atm__countdown-timer__countdown__hours__colon">:</div>
              </div>
              <!-- Minutes -->
              <div id="shopify-countdown-timer__countdown__minutes" class="atm__countdown-timer__countdown__minutes">
                <div class="atm__countdown-timer__countdown__minutes__wrapper">
                  <div class="atm__countdown-timer__countdown__minutes__number">
                    <span class="atm__countdown-timer__countdown__minutes__decade" id="atm__countdown-timer__countdown__minutes__decade">
                      ${parseInt(minutes / 10)}
                    </span>
                    <span class="atm__countdown-timer__countdown__minutes__unit" id="atm__countdown-timer__countdown__minutes__unit">
                      ${minutes % 10}
                    </span>
                  </div>
                  <div class="atm__countdown-timer__countdown__minutes__minutes">Mins</div>
                </div>
                <div class="atm__countdown-timer__countdown__minutes__colon">:</div>
              </div>
              <!-- Seconds -->
              <div id="shopify-countdown-timer__countdown__seconds" class="atm__countdown-timer__countdown__seconds">
                <div class="atm__countdown-timer__countdown__seconds__wrapper">
                  <div class="atm__countdown-timer__countdown__seconds__number">
                    <span class="atm__countdown-timer__countdown__seconds__decade" id="atm__countdown-timer__countdown__seconds__decade">
                      ${parseInt(seconds / 10)}
                    </span>
                    <span class="atm__countdown-timer__countdown__seconds__unit" id="atm__countdown-timer__countdown__seconds__unit">
                      ${seconds % 10}
                    </span>
                  </div>
                  <div class="atm__countdown-timer__countdown__seconds__seconds">Secs</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `
    );

    timerInterval = setInterval(function () {
      var timeLeft = getTimeLeft(endTime);
      // console.log(timeLeft);

      if (timeLeft >= 0) {
        makeTimer(timeLeft);
      } else {
        window.clearInterval(timerInterval);
        if (
          thisJQuery("main form").find("#shopify-countdown-timer").length > 0
        ) {
          thisJQuery("main form")
            .children("#shopify-countdown-timer")
            .remove();
        }
      }
    }, 1000);
  }
  function saleEndsSoon(formEle, endTime) {
    setTimeoutId && clearTimeout(setTimeoutId);
    
    var timeLeft = getTimeLeft(endTime);
    var left = timeLeft * 1000 - 7 * 86400 * 1000;
    formEle.append(
      `<div id="shopify-countdown-timer" 
            class="atm__countdown-timer">
            <div class="atm__countdown-timer__wrapper">
                  <div id="shopify-countdown-timer__countdown"
                    class="atm__countdown-timer__countdown">
                     <div id="shopify-countdown-timer__countdown__title"
                          class="atm__countdown-timer__countdown__title-soon">
                          <div class="atm__countdown-timer__countdown__title-soon__up">
                            <div class="atm__countdown-timer__countdown__title-soon__up__item">
                              <span  class="atm__countdown-timer__countdown__title-soon__up__item__letter">S</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__up__item__letter">A</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__up__item__letter">L</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__up__item__letter">E</span>
                            </div>
                          </div>
                          <div  class="atm__countdown-timer__countdown__title-soon__bottom">
                            <div  class="atm__countdown-timer__countdown__title-soon__bottom__item">
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">E</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">N</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">D</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">S</span>
                            </div>
                            <div  class="atm__countdown-timer__countdown__title-soon__bottom__item">
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">S</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">O</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">O</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">N</span>
                              <span  class="atm__countdown-timer__countdown__title-soon__bottom__item__letter">!</span>
                            </div>
                          </div>
                      </div>
                  </div>
            </div>
      </div>`
    );
    setTimeoutId = setTimeout_(function () {
      saleEndsIn(formEle, endTime);
    }, left);
  }

  function makeApp(startTime, endTime) {
    /**
     * 1. has no end date time, don't show anything
     * 2. has end date time and ends in longer than 7days show sales end soon
     * 3. has end date time and ends in 7 days show countdown timer
     */
    const timeLeft = getTimeLeft(endTime);
    const daysLeft = Math.floor(timeLeft / 86400);
    const formEle = thisJQuery("main form");

    if (
      thisJQuery("main form").find("#shopify-countdown-timer").length > 0
    ) {
      thisJQuery("main form")
        .children("#shopify-countdown-timer")
        .remove();
    }
    
    if (endTime && timeLeft > 0) {
      if (daysLeft < 7) {
        saleEndsIn(formEle, endTime);
      } else {
        saleEndsSoon(formEle, endTime);
      }
    }
  }

  //add css to head
  addCountdownTimerCss();

  (function () {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
  
    function onUrlChange() {
      atomdot.countdowntimer.showCountdownTimer();
    }
  
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      onUrlChange();
    };
  
    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      onUrlChange();
    };
  
    window.addEventListener("popstate", onUrlChange);
  })();
  
  if (typeof ShopifyAnalytics.meta.product !== "undefined") {
    atomdot.countdowntimer.showCountdownTimer = function () {   
      const vid = getProductVariantId();
      variantPromo = __vm__[vid.toString()]?.promo;
      makeApp(null, variantPromo?.scheduleToEndAt);
    };

    atomdot.countdowntimer.showCountdownTimer();
  }

  window.atomdot = atomdot;
})(window);
